function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useContext, useMemo, useState } from 'react';
import styles from './RecordCompareArrayGroup.module.scss';
import CompareContext, { CompareContextOverride } from './RecordCompareContext';
import stripHtml from '../../../utils/stripHtml';
import Accordion from '../../../Accordion/Accordion/Accordion';
import AccordionItem from '../../../Accordion/AccordionItem/AccordionItem';
import Pagination from '../../../Tables/Pagination/Pagination';
import ArrayRow from './RecordCompareArrayRow';
import ArrayHeader from './RecordCompareArrayHeader';
import { getPageCount, getPagedItems } from '../../util/recordComparePagination';
import filterLayoutToVisibleFromSchema from '../../util/recordCompareFilterLayoutToVisibleFromSchema';
import filterLayoutToVisibleFromRecords from '../../util/recordCompareFilterLayoutToVisibleFromRecords';
import RecordCompareStateContext from '../../RecordCompareStateContext';
var PAGE_SIZE = 20;
function getTitle(schema, uiSchema, property) {
  var uiTitle = uiSchema[property]['ui:title'];
  if (!!uiTitle) {
    return stripHtml(uiTitle.text);
  }
  var schemaProperty = schema.properties[property];
  var schemaTitle = schemaProperty ? schemaProperty.title : null;
  if (!!schemaTitle) {
    return stripHtml(schemaTitle);
  }
  return '';
}
function getChildRecord(record, property) {
  var uiSchema = record.uiSchema[property].items;
  var schema = record.schema.properties[property].items;
  var data = record.data[property] || [];
  return Object.assign({}, record, {
    uiSchema: uiSchema,
    schema: schema,
    data: data,
    layout: filterLayoutToVisibleFromSchema(uiSchema['dm:layout'], schema)
  });
}
export default function ArrayGroup(_ref) {
  var property = _ref.property;
  var _useContext = useContext(CompareContext),
    mergeRecord = _useContext.mergeRecord,
    records = _useContext.records;
  var isMergeEnabled = useContext(RecordCompareStateContext);
  var childRecords = useMemo(function () {
    return records.map(function (record) {
      return getChildRecord(record, property);
    });
  }, [records, property]);
  var childMergeRecord = useMemo(function () {
    return getChildRecord(mergeRecord, property);
  }, [mergeRecord, property]);
  var childLayout = useMemo(function () {
    return filterLayoutToVisibleFromRecords(childRecords[0].uiSchema['dm:layout'], childRecords);
  }, [childRecords]);
  var rows = useMemo(function () {
    var size = childRecords.reduce(function (acc, record) {
      return Math.max(acc, record.data ? record.data.length : 0);
    }, 1);
    var result = [];
    var _loop = function _loop(index) {
      result.push(childRecords.map(function (childRecord) {
        return Object.assign({}, childRecord, {
          hasData: index < childRecord.data ? childRecord.data.length : 0,
          data: childRecord.data[index] || {}
        });
      }));
    };
    for (var index = 0; index < size; index++) {
      _loop(index);
    }
    return result;
  }, [childRecords]);
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    page = _useState2[0],
    setPage = _useState2[1];
  var pages = getPageCount(rows, PAGE_SIZE);
  var pagedRows = useMemo(function () {
    if (pages === 1) {
      return rows;
    }
    return getPagedItems(rows, page, PAGE_SIZE);
  }, [rows, page, pages]);
  var title = useMemo(function () {
    return getTitle(mergeRecord.schema, mergeRecord.uiSchema, property);
  }, [mergeRecord, property]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(Accordion, null, /*#__PURE__*/React.createElement(AccordionItem, {
    title: title,
    defaultOpen: true
  }, isMergeEnabled && /*#__PURE__*/React.createElement(ArrayHeader, {
    property: property,
    rows: rows,
    title: title
  }), pagedRows.map(function (entry, rowNumber) {
    return /*#__PURE__*/React.createElement(CompareContextOverride, {
      key: "context-".concat(page, "-").concat(rowNumber),
      layout: childLayout,
      records: entry,
      mergeRecord: childMergeRecord
    }, /*#__PURE__*/React.createElement(ArrayRow, {
      key: "row-".concat(page, "-").concat(rowNumber),
      parentUiSchema: mergeRecord.uiSchema,
      property: property,
      rowNumber: (page - 1) * PAGE_SIZE + rowNumber
    }));
  }), pages > 1 && /*#__PURE__*/React.createElement(Pagination, {
    page: page,
    pages: pages,
    onPageChange: setPage,
    "aria-label": title
  }))));
}